import React from "react";
import { cn } from "lib/utils";

/**
 * Chip da categoria da modalidade (Sub-15 Masculino, Adulto Feminino…).
 *
 * Um componente so para o card publico, o formulario (previa) e as listas do
 * painel: as cores vem do cadastro da categoria e o chip precisa sair igual em
 * todo lugar. `chip` e o `sport_category_chip` que a API devolve
 * ({ name, background_color, text_color }).
 */
export function SportCategoryChip({ chip, className }) {
  if (!chip?.name) return null;
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold",
        className
      )}
      style={{ backgroundColor: chip.background_color, color: chip.text_color }}
    >
      {chip.name}
    </span>
  );
}

export default SportCategoryChip;
